import { defineMessages } from 'react-intl';

export default defineMessages({
  passed: {
    id: 'ReactFilters.messages.relative.passed',
    defaultMessage: 'Passed',
  },
  current: {
    id: 'ReactFilters.messages.relative.current',
    defaultMessage: 'Current',
  },
  upcoming: {
    id: 'ReactFilters.messages.relative.upcoming',
    defaultMessage: 'Upcoming',
  },
});
